module.exports = __webpack_public_path__ + "static/media/fix_cash.d4c1441e.png";